import React from 'react';
import styled from 'styled-components';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../stateProvider/StateProvider';
import { generateId, shortHandDateTime } from '../../utility/functions';
import Button from '../../forms/Button';
import Table from '../../table/Table';
import Heading from '../../forms/Heading';
import Input from '../../forms/Input';
import LinkTo from '../../forms/LinkTo';
import GetState from '../../GetState';
import Form from '../../forms/Form';
import Checkbox from '../../forms/Checkbox';
import { userRoles } from '../../RoleProtected';
import ModalFactory from '../../Modal';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    align-items: flex-start;
    width: 100%;
`

const LoyaltyPoints = ({ ...props }) => {
    const { guid } = useParams();

    const [data, refresh] = GetState(QuestRoute.user.loyaltyPoints(guid), { loading: [] });

    const adjustPoints = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Adjust Points',
            body: (
                <Form
                    inputs={{ amount: '', deduct: false }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.user.loyaltyPoints(guid), { ...e })
                            .then(() => {
                                refresh()
                                ModalFactory.update({
                                    id,
                                    title: 'Success',
                                    body: `Successfully ${e.deduct ? 'removed' : 'added'} ${e.amount} points.`,
                                    type: 'success'
                                })
                            })
                            .catch(ModalFactory.catch)
                    )}
                >
                    {({ values, setValue }) => <>
                        <span>Add or deduct loyalty points from the user.</span>
                        <Input
                            label='Points'
                            name='amount'
                            type='number'
                            callback={e => setValue('deduct', e < 0)}
                            required
                        />
                        <Checkbox
                            label='Deduct'
                            name='deduct'
                            callback={e => setValue('amount', e ? values.amount * -1 : Math.abs(values.amount))}
                            disabled={values.amount === 0}
                        />
                    </>}

                </Form>
            )
        })
    }


    const tableConfig = {
        data: data.audit,
        controls: [<Button roles={userRoles.editCustomers} onClick={adjustPoints}>Adjust Points</Button>],
        disableHeaderSearch: true,
        headers: [
            {
                label: 'Points Earned',
                propKey: 'pointsEarned',
            }, {
                label: 'Date',
                propKey: 'date',
                type: 'date'
            }, {
                label: 'Total',
                propKey: 'total',
            }, {
                label: 'Points To Goal',
                propKey: 'pointsToGoal',
            }, {
                label: 'Adjusted By',
                propKey: 'adjustedBy',
            }, {
                label: 'Record',
                propKey: 'recordID',
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.pointsEarned}</td>
                <td>{shortHandDateTime(e.date)}</td>
                <td>{e.total}</td>
                <td>{e.pointsToGoal}</td>
                <td>{e.adjustedBy}</td>
                <td>
                    <LinkTo
                        target='_blank'
                        to={'/reporting/sales/transaction/' + e.recordID}>{e.recordID}</LinkTo>
                </td>
            </tr>
        )
    }

    return (
        <Wrapper>
            <Heading>Loyalty Points</Heading>
            {data.isConfigured ?
                <>
                    <Input
                        label='Current Points'
                        value={data.current ?? 0}
                        disabled={true}
                        readOnly
                        standalone
                    />
                    <Table
                        config={tableConfig}
                    />
                </>
                : <Button to='/mobile/loyaltyPoints'>Configure Loyalty Points</Button>
            }
        </Wrapper>
    );
}

export default LoyaltyPoints;
